import React from 'react';
import Header from "../menu/Header";
import Menu from "../menu/Menu";
import { AiOutlineUser } from "react-icons/ai";
import { useEffect,useState } from 'react';
import { getAllMessages } from '../../../services/kojaServices';
import logoMobile from "../../../assets/logoa2.png";
import { FaArrowLeft } from "react-icons/fa";

const Message = () => {
  const [list,setList] = useState([])
  const [selectedMessage,setSelectedMessage] = useState({})
  const [mobileMessage,setMobileMessage] = useState(false)

    useEffect(() => {
        const fetchData = async () => {
          try {
            const { data } = await getAllMessages();
            console.log(data);
            setList(data.result)
          } catch (err) {
            console.log(err);
          }
        };
        fetchData();
      }, []);


    return (
        <div  style={{paddingTop:"10px",backgroundColor:"#739fb1", minHeight:"100vh"}}>
        <Header />
        <div
        className="d-flex request-box-content"
        style={{ margin: "20px 30px 0px 30px" }}
      >
        <Menu />
        <div className="w-100 text-center d-flex flex-column align-items-start justify-content-start">
        <div className='message-header-box d-none d-md-block p-2'>پیام های دریافتی</div>
          <div className='row d-none d-md-flex message-box'>
          <div className='col-md-6 '>
            {
              list.map((i,index)=>(
                <div key={index} className='item-message-box d-flex justify-content-between align-items-center mb-2'
                onClick={()=>{setSelectedMessage(i)}}
                >
                <div className='message-user-icon'>
                <AiOutlineUser/>
                </div>
                <span>{i.title}</span>
                <span>{new Intl.DateTimeFormat('fa-IR').format(new Date(i.createdAt))}</span>
                </div>
              ))
            }
            </div>
          <div className='col-6 message-content-box align-self-start'>
          <img alt="" src={logoMobile} className="user-menu-logo" style={{width:"80px",height:"80px",borderRadius:"40px"}} />
            <p className='message-title'>{selectedMessage.title || ""}</p>
            <div className='message-text-box text-end p-3'>{selectedMessage.content}</div>
          </div>
          </div>
          {
            mobileMessage ? (
              <div className='w-100'>
              <div className='message-header-box d-flex align-items-center justify-content-between mb-2 p-2'>
              <p className='mb-0'>پیام های دریافتی</p>
              <button className='btn d-md-none' onClick={()=>{setMobileMessage(false)}}><FaArrowLeft/></button>
                 </div>
              <div className='col-12 message-content-box mt-2 p-2'>
                <img alt="" src={logoMobile} className="user-menu-logo" style={{width:"80px",height:"80px",borderRadius:"40px"}} />
                  <p className='message-title'>{selectedMessage.title}</p>
                  <div className='message-text-box text-end p-3'>{selectedMessage.content}</div>
                </div>
              </div>
            ): (
              <div className='row d-md-none  message-box'>
              <div className='message-header-box  mb-2 p-2'>پیام های دریافتی</div>
                <div className='col-12 '>
                  {
                    list.map((i,index)=>(
                      <div key={index} 
                      className='item-message-box d-flex justify-content-between align-items-center mb-2'
                      onClick={()=>{setSelectedMessage(i)
                      setMobileMessage(true)
                      }}
                      >
                      <div className='message-user-icon'>
                      <AiOutlineUser/>
                      </div>
                      <span>{i.title}</span>
                      <span>{new Intl.DateTimeFormat('fa-IR').format(new Date(i.createdAt))}</span>
                      </div>
                    ))
                  }
                  </div>
          </div>
            )
          }
        </div>
      </div>
        </div>
    );
};

export default Message;